var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import EyeOffIcon from "../../assets/icons/feather/eye-off.svg";
import { Link, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import EyeIcon from "../../assets/icons/feather/eye.svg";
import { useNavigate, useParams } from "react-router";
import ForgetPassword from "../../shared/auth/forgetpassword";
import logoESans from "../../assets/images/logo-renkli.png";
import leftArrow from "../../assets/icons/chevron-left.svg";
var s;
var resendButton;
import "./auth.css";
import { api } from "../../services/http.service";
import { agreements, env, professions } from "../../constants/global.constants";
import InputMask from "react-input-mask";
import { isMobile } from "../../App";
import { gtmUserEvent } from "../../services/misc.functions";
import paths from "../../paths";
import { AuthService, LoginFromWhere } from "../../services/auth.service";
import { modalServiceSubject } from "../../services/modal.service";
import InputAuto from "../../shared/auth/input.auto";
export function Login() {
    var searchParams = useSearchParams()[0];
    var params = useParams();
    var navigate = useNavigate();
    var _a = useState(null), errorMessage = _a[0], setErrorMessage = _a[1];
    var _b = useState(false), passwordModal = _b[0], showPasswordModal = _b[1];
    var _c = useState(false), showCodeField = _c[0], setShowCodeField = _c[1];
    var _d = useState(false), showProfessionField = _d[0], setShowProfessionField = _d[1];
    var _e = useState(false), showPhoneNumber = _e[0], setShowPhoneNumber = _e[1];
    var _f = useState(""), updatedMobile = _f[0], setUpdatedMobile = _f[1];
    var _g = useForm(), register = _g.register, handleSubmit = _g.handleSubmit, reset = _g.reset, getValues = _g.getValues, setValue = _g.setValue, clearErrors = _g.clearErrors, errors = _g.formState.errors;
    var senderTimer = function (s) {
        if (s === void 0) { s = null; }
        var resendTimer = document.getElementById("id_resendTimer");
        if (resendTimer) {
            var secondLeft = Number(Number(resendTimer.innerHTML.split(":")[0]) * 60 + Number(resendTimer.innerHTML.split(":")[1]) - 1);
            if (secondLeft < 0) {
                clearInterval(s);
                resendButton = document.getElementById("id_resendCode");
                if (resendButton) {
                    resendButton.classList.remove("hide");
                }
            }
            else {
                resendTimer.innerHTML = Math.floor(secondLeft / 60) + ":" + ("00" + (secondLeft % 60)).slice(-2);
            }
        }
    };
    var doLogin = function (payload) {
        var authService = new AuthService(searchParams, navigate);
        var loginButton = document.getElementById("id_btnLogin");
        if (loginButton) {
            loginButton.disabled = true;
        }
        authService
            .login(payload, LoginFromWhere.LOGIN_PAGE)
            .then(function (response) {
            if (loginButton) {
                loginButton.disabled = false;
            }
            if (response.status === false) {
                if (response.error === "sms_validate") {
                    setShowCodeField(response.data);
                    payload.mobile = response.data.mobile;
                    clearInterval(s);
                    s = setInterval(senderTimer, 1000);
                }
                if (response.error === "agreement_required") {
                    var content = agreements["uyelik-sozlesmesi"];
                    modalServiceSubject.next({
                        title: content.title,
                        content: content.content,
                        width: 720,
                        confirm: {
                            cancel: {
                                label: "Vazgeç",
                            },
                            sure: {
                                label: "Kabul Et",
                                class: "btn-info  w-100",
                                action: function () {
                                    payload["is_checked"] = true;
                                    doLogin(payload);
                                },
                            },
                        },
                    });
                    return;
                }
                setErrorMessage(response.message);
                return;
            }
            if (response.error === "profession_error") {
                setShowProfessionField(true);
                setErrorMessage(response.message);
                return;
            }
            gtmUserEvent("login");
            reset({
                user: "",
                password: "",
            });
            setErrorMessage(null);
            setShowCodeField(false);
            if (params.nextPage != null) {
                navigate(params.nextPage.replaceAll("|", "/"));
            }
            else {
                navigate(paths.home.url);
            }
        })
            .catch(function (e) {
            if (loginButton) {
                loginButton.disabled = false;
            }
            setErrorMessage(e.message || e);
        });
    };
    var onSubmit = function (payload) {
        if (!showCodeField) {
            doLogin(payload);
        }
        else {
            var authService = new AuthService(searchParams, navigate);
            payload.mobile = showCodeField.mobile;
            authService
                .validateMobile(payload, payload.code)
                .then(function (res) {
                if (res && res.status) {
                    payload.validation_token = res.data.validation_token;
                    doLogin(payload);
                    return;
                }
                else {
                    setErrorMessage(res.message);
                }
            })
                .catch(function (err) {
                setErrorMessage(err);
            });
        }
    };
    useEffect(function () {
        return function () {
            clearInterval(s);
        };
    }, []);
    var isPasswordVisible = function () {
        var password = document.getElementById("password");
        var eyeIcon = document.getElementById("eye-icon");
        if (password.type === "password") {
            password.type = "text";
            eyeIcon.src = EyeIcon;
        }
        else {
            password.type = "password";
            eyeIcon.src = EyeOffIcon;
        }
    };
    function closePasswordModal() {
        showPasswordModal(false);
    }
    function updatePhoneNumber() {
        api
            .start("post", env.accounting_api + "/member/api/change-mobile/", {
            mobile: updatedMobile.replaceAll("(", "").replaceAll(")", "").replaceAll(" ", ""),
            user: getValues("user"),
            password: getValues("password"),
        }, false)
            .then(function (res) {
            if (res && res.status) {
                setShowPhoneNumber(false);
                doLogin({
                    user: getValues("user"),
                    password: getValues("password"),
                });
            }
            else {
                setErrorMessage(res.message);
            }
        })
            .catch(function (e) {
            setErrorMessage(e);
        });
    }
    return (_jsx(_Fragment, { children: _jsxs("div", __assign({ className: "page-login" }, { children: [!isMobile && (_jsx("div", __assign({ className: "backButton", onClick: function () {
                        history.back();
                    } }, { children: _jsx("img", { src: leftArrow }) }))), _jsx(Link, __assign({ className: "branding-big mx-3 px-1 pointer", to: paths.home.url }, { children: _jsx("img", { src: logoESans }) })), _jsx("div", { className: "clearfix" }), _jsxs("div", __assign({ className: "login-container login-modal" }, { children: [_jsx("h2", { children: "Giri\u015F Yap" }), errorMessage && _jsx("p", __assign({ className: "alert text-center alert-danger" }, { children: errorMessage })), _jsxs("form", __assign({ onSubmit: handleSubmit(onSubmit) }, { children: [_jsxs("div", __assign({ className: "mt-2" }, { children: [_jsx("label", __assign({ className: "login-label" }, { children: "Telefon No / TC Kimlik No" })), _jsx(InputMask, __assign({ maskChar: "", mask: "99999999999", className: "form-control", placeholder: "" }, register("user", { required: true }))), errors.user && _jsx("div", __assign({ className: "invalid-feedback d-block" }, { children: "TCKN yada Telefon gereklidir." }))] })), _jsxs("div", __assign({ className: "mt-2 position-relative" }, { children: [_jsx("label", __assign({ className: "login-label" }, { children: "\u015Eifre" })), _jsx("input", __assign({ type: "password", className: "form-control", id: "password" }, register("password", { required: true }))), errors.password && _jsx("div", __assign({ className: "invalid-feedback d-block" }, { children: "\u015Eifre gereklidir." })), _jsx("div", __assign({ className: "cursor-pointer eye-icon float-right mr-2 position-absolute", onClick: function () { return isPasswordVisible(); } }, { children: _jsx("img", { id: "eye-icon", height: 16, width: 16, src: EyeOffIcon }) }))] })), _jsx("div", __assign({ className: "mt-4 position-relative" }, { children: _jsxs("div", __assign({ className: "col" }, { children: [_jsx("input", __assign({ type: "checkbox", id: "remind", className: "form-check-input float-end me-3", defaultChecked: true }, register("remind", { required: false }))), _jsx("label", __assign({ className: "login-label float-end me-3" }, { children: "Beni Hat\u0131rla" }))] })) })), showProfessionField && (_jsx("div", __assign({ className: "py-3" }, { children: _jsx(InputAuto, { label: "Meslek Bilgisi", pholder: "Meslek Se\u00E7iniz", data: professions, register: register, name: "profession", setValue: setValue, clearErrors: clearErrors, error: errors.profession }) }))), showCodeField && (_jsxs("div", __assign({ className: "mt-4 position-relative" }, { children: [_jsxs("p", __assign({ className: "my-2 alert alert-info" }, { children: ["Oturum a\u00E7abilmek ve \u00FCyelik i\u015Fleminizi tamamlayabilmek i\u00E7in", _jsxs("b", { children: [" ", showCodeField.mobile] }), " numaral\u0131 telefonunuza g\u00F6nderdi\u011Fimiz do\u011Frulama kodunu giriniz."] })), _jsx("div", __assign({ className: "my-2 mx-2" }, { children: _jsx("button", __assign({ type: "button", className: "btn w-100 btn-warning mt-2 ", onClick: function () {
                                                    setShowPhoneNumber(true);
                                                } }, { children: "Telefon Numaram\u0131 de\u011Fi\u015Ftir" })) })), showPhoneNumber ? (_jsx(_Fragment, { children: _jsxs("div", __assign({ className: "col-12 col-mobile-12" }, { children: [_jsx("label", __assign({ htmlFor: "id_mobile", className: "form-label" }, { children: "Telefon Numaras\u0131" })), _jsx(InputMask, { mask: "(599) 999 99 99", className: "form-control", placeholder: "(___) ___ __ __", onChange: function (evt) { return setUpdatedMobile(evt.target.value); } })] })) })) : (_jsxs(_Fragment, { children: [_jsx("label", { children: "Do\u011Frulama Kodu" }), _jsx("div", __assign({ id: "emailHelp", style: { right: 10, marginTop: 10 }, className: "form-text position-absolute" }, { children: _jsx("span", __assign({ id: "id_resendTimer" }, { children: "3:00" })) })), _jsx("button", __assign({ type: "button", onClick: function () {
                                                        // const authService = new AuthService(searchParams, navigate);
                                                        // authService.sendValidationCode(showCodeField);
                                                        // resendButton.classList.add("hide");
                                                        // let resendTimer: any = document.getElementById("id_resendTimer");
                                                        // if (resendTimer) {
                                                        //     resendTimer.innerHTML = "0:30";
                                                        // }
                                                        // clearInterval(s);
                                                        // s = setInterval(senderTimer, 1000);
                                                        clearInterval(s);
                                                        var authService = new AuthService();
                                                        authService.getLoginSMSValidationCode({ mobile: showCodeField.mobile }).then(function (res) {
                                                            if (res && res.status) {
                                                                if (resendButton) {
                                                                    resendButton.classList.add("hide");
                                                                }
                                                                var resendTimer = document.getElementById("id_resendTimer");
                                                                if (resendTimer) {
                                                                    var timeout = res.data.timeout || 180;
                                                                    resendTimer.innerHTML = Math.floor(timeout / 60) + ":" + ("00" + (timeout % 60)).slice(-2);
                                                                }
                                                                s = setInterval(senderTimer, 1000);
                                                            }
                                                            else {
                                                                setErrorMessage(res.message);
                                                            }
                                                        }).catch(function (e) {
                                                            console.error(e);
                                                        });
                                                    }, style: {
                                                        right: 10,
                                                        bottom: 8,
                                                        fontSize: 13,
                                                        padding: "0px 5px",
                                                    }, className: "btn hide btn-sm position-absolute btn-warning", id: "id_resendCode" }, { children: "Tekrar G\u00F6nder" })), _jsx(InputMask, __assign({ mask: "999 999", className: "form-control", placeholder: "___ ___" }, register("code", { required: true }))), errors.code && _jsx("div", __assign({ className: "invalid-feedback d-block" }, { children: "Do\u011Frulama kodu gereklidir." }))] }))] }))), showPhoneNumber ? (_jsx("div", __assign({ className: "mt-2 mx-2" }, { children: _jsx("button", __assign({ type: "button", className: "btn btn-primary mt-2 login-btn", onClick: function () {
                                            updatePhoneNumber();
                                        } }, { children: "G\u00FCncelle" })) }))) : (_jsx("div", __assign({ className: "mt-2 mx-2" }, { children: _jsx("input", { type: "submit", id: "id_btnLogin", className: "btn btn-green mt-2 login-btn", value: "Giri\u015F Yap" }) }))), _jsx("div", __assign({ className: "forget-password-link", onClick: function () {
                                        showPasswordModal(true);
                                    } }, { children: "\u015Eifremi Unuttum" })), _jsx("hr", {}), _jsx(Link, __assign({ className: "btn w-100 btn-outline-green", to: paths.register.url }, { children: "\u00DCcretsiz \u00DCye Ol" })), _jsx("ul", {})] })), _jsxs("div", __assign({ className: "adult-warning-text" }, { children: [_jsx("span", __assign({ className: "p-1 rounded fs-7 text-white bg-danger me-2" }, { children: "+18" })), _jsx("span", { children: "e-\u015Eans'a 18 ya\u015F\u0131ndan b\u00FCy\u00FCkler \u00FCye olabilir." })] }))] })), _jsx(ForgetPassword, { passwordModal: passwordModal, closePasswordModal: closePasswordModal })] })) }));
}
